import { IonNote, IonProgressBar, IonLoading, IonCardHeader, IonCardTitle, IonCardSubtitle, IonRange, IonCardContent, IonSpinner, IonChip, useIonRouter, IonGrid, IonText, IonImg, IonAlert, IonFabButton, IonFab, IonSearchbar, IonInfiniteScrollContent, IonInfiniteScroll, IonIcon, IonRefresherContent, IonRefresher, IonBackButton, IonButton, IonButtons, IonCard, IonCheckbox, IonCol, IonContent, IonHeader, IonInput, IonItem, IonLabel, IonList, IonPage, IonRow, IonTitle, IonToolbar, useIonViewWillEnter } from "@ionic/react";
import React, { useState, useEffect } from "react";
import { heart, warningOutline, rocketOutline, readerOutline } from 'ionicons/icons';
import { RouteComponentProps } from "react-router-dom";
import { Dialog, ConfirmResult } from '@capacitor/dialog';

import { LANGUAGE, GetStr } from "../language/Language";
import { Storage } from '@capacitor/storage';   
import NServer, { handleRouteError } from "../components/NServer";
import Vault from '../components/Vault';
import { showAlert, showConfirm } from '../components/Alert';
import ContentMini from '../components/ContentMini';
import { ContentInfo, ContentInterface, ContentUpdateInt, ItemInfo, CommentInfo, CreateContentInfo, ContentDetail, CountNum } from '../data/item';

import './Main.css';  

interface BoostReportProp extends RouteComponentProps<{
    id : any
    }> 
{}

interface ReportItem {
    id : number,
    amount : number,
    spent : number,
    views : number,
    created : string,
    status : string
}


const BoostReport : React.FC<BoostReportProp> = ({match}) => {
    const [showLoading, setShowLoading] = useState(false);
    const [content, setContent] = useState<ContentInfo>(CreateContentInfo(0, "", "", "/assets/img/avt.jpg"));
    const [report, setReport] = useState<ReportItem[]>([]);
    const router = useIonRouter();

    useIonViewWillEnter(() => {
        getData();
    });

    // need to refresh
    useEffect(() => {
        // init
        getData();
    },[match.params.id]);

    const getData = async () => {

        setShowLoading(true);

        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            content: match.params.id
        }

        var server = new NServer();
        await server.getList("nc_boost_report", state);
        if (!server.success && server.message != "")
        {
            showAlert(server.message);
            // handle route error if there is any
            handleRouteError(router, server.data);
        }
        else
        {
            setContent(server.data.content);
            setReport(server.data.report);
        }

        setShowLoading(false);
	}

    const doRefresh = async (ev : any) => {
        await getData();
        ev.detail.complete();
    };

    // go to likes
    const buyLike = () => {
        router.push("/token/wallet", "forward", "push");
    }

    return (
        <IonPage>
            <IonHeader className="ion-no-border">
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonBackButton text="" defaultHref="/home" ></IonBackButton>
                    </IonButtons>
                    <IonTitle className="title"><h5>{ GetStr(LANGUAGE.TXT_BOOST_REPORT_CAP) }</h5></IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent>
                <IonRefresher  slot="fixed" onIonRefresh={doRefresh}>
                    <IonRefresherContent></IonRefresherContent>
                </IonRefresher>
                
                <IonGrid className="ion-no-padding full-content">
                    <IonRow>
                        <IonCol>
                        </IonCol>
                        <IonCol size-md="10" size-lg="8" size-xl="6" size="12">
                            {
                                /* content */
                                content.id > 0 ?
                            <IonCard className="flat-card">
                                <ContentMini content={content} />
                            </IonCard>
                                :
                            <div/>
                            }
                            
                            <IonCard className="flat-card">
                                {
                                    /* reports */
                                    report != null && report.length > 0 ? 
                                <IonList>
                                    {
                                        report.map( (m) => 
                                    <IonItem key={m.id} detail={false} lines="none">
                                        <IonIcon icon={ m.status == "finished" ? readerOutline : (m.status == "canceled" ? warningOutline : rocketOutline) } slot="start" />
                                        <IonLabel className="ion-text-wrap">
                                            <h2>Views: { m.views }</h2>
                                            <h2>Tokens Spent: { m.spent } / { m.amount }</h2>
                                            <IonNote>
                                                Status: <b>
                                                    { 
                                                        m.status == "finished" ? 
                                                    <IonText>Finished</IonText>
                                                        : 
                                                        m.status == "canceled" ? 
                                                    <IonText color="danger">Canceled</IonText>
                                                        :
                                                    <IonText color="success">Running</IonText>
                                                    }
                                                </b><br/>
                                                <small>{ m.created }</small>
                                            </IonNote>
                                        </IonLabel>
                                    </IonItem>
                                    ) }
                                </IonList>
                                    :
                                <IonCardContent className="ion-margin ion-text-center">
                                    { GetStr(LANGUAGE.TXT_NO_BOOST_DATA) }
                                </IonCardContent> 
                                }
                            </IonCard>

                            <IonLoading
                                isOpen={showLoading}
                                onDidDismiss={() => setShowLoading(false)}
                                message={ GetStr(LANGUAGE.TXT_PLZ_WAIT) }
                            />
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonContent>
        </IonPage>
    );
};
export default BoostReport;